import script from "./showIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./showIndex.vue?vue&type=script&setup=true&lang=js"

import "./showIndex.vue?vue&type=style&index=0&id=5d6bd031&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d6bd031"]])

export default __exports__